import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { constant } from '../public/config/Const';
import i18n from './common/i18n';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { createHead } from 'unhead';

// 定数(調査)
const app = createApp(App);
app.config.globalProperties.$constProperties = constant;

const pinia = createPinia();
pinia.use(createPersistedState());
// `import.meta.env.MODE` を確認して、開発モード時のみ MSW を有効化する
if (process.env.NODE_ENV === 'development') {
    const { worker } = require('./mocks/browser');
    worker.start({
        onUnhandledRequest: 'bypass',
    });
}
const head = createHead();
app.use(router).use(i18n).use(pinia).use(head).mount('#app');
